var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "../classes/BaseService";
import { StorageAdapterContext } from "./StorageAdapterContext";
export class StorageService extends BaseService {
    constructor(framework) {
        super({
            initialState: {},
        });
        this.storage = new Map();
        this.cache = new Map();
        this.framework = framework;
        this.context = new StorageAdapterContext(this.storage, this);
    }
    init(adapter) {
        return __awaiter(this, void 0, void 0, function* () {
            this.adapter = adapter;
            this.initAdapter(adapter, this.context);
        });
    }
    get(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getSync(key);
        });
    }
    set(key, value, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const nextValue = (options === null || options === void 0 ? void 0 : options.encode)
                ? options.encode(value)
                : JSON.stringify(value);
            if (this.storage.has(key) && this.storage.get(key) === nextValue) {
                return;
            }
            if (!this.adapter) {
                return void console.warn("StorageService.set was called before an adapter was supplied", key, value);
            }
            return yield this.adapter.set(key, nextValue);
        });
    }
    delete(key) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.adapter.delete(key);
        });
    }
    keys() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._keysSync();
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.adapter.clear();
        });
    }
    _getSync(key, options) {
        if (this.cache.has(key)) {
            return this.cache.get(key);
        }
        if (this.storage.has(key)) {
            const cache = (options === null || options === void 0 ? void 0 : options.decode)
                ? options.decode(this.storage.get(key))
                : JSON.parse(this.storage.get(key));
            this.cache.set(key, cache);
            return cache;
        }
        return undefined;
    }
    _keysSync() {
        return Array.from(this.storage.keys());
    }
    _clearCache(key) {
        this.cache.delete(key);
    }
}
//# sourceMappingURL=StorageService.js.map